const Statistics = () =>
  import(
    /* webpackChunkName: "reports-statistics" */ '@/pages/report/statistics/index.vue'
  )


export default {
  path: 'statistics',
  meta: {
    label: 'statistics',
    auth: 'statistics'
  },
  component: {
    name: 'Statistics',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'ReportStatistics',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Statistics
    }
  ]
}
